function fn_comp_visual() {
    var $comp = $(".comp_visual");
    var $comp_visual = $comp.find(".visual");
    var $data_autoplay = $comp_visual.data("autoplay");

    $comp_visual.slick({
        infinite: true,
        speed: 500,
        fade: true,
        cssEase: 'linear',
        autoplay: true,
        autoplaySpeed: $data_autoplay,
        arrows: false,
        dots: true
    });
    $comp_visual.on('beforeChange', function(){
        $(this).find(".slick-active").next().find("img").addClass("lazyload").on('lazybeforeunveil', function(){
            $(this).parent().parallax();
        });
    });
    $comp_visual.on('afterChange', function(){
        $(this).find(".slick-active").find("img").addClass("lazyload");
    });
    $comp_visual.find("img").on('lazybeforeunveil', function(){
        $(this).parent().parallax();
    });
}